module.exports = __webpack_public_path__ + "static/img/vistanekretnine.998f5cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/vistanekretnine.png
// module id = MkP9
// module chunks = 0